export default __webpack_public_path__ + "static/molly-desktop-dd59afa8541d28d48862d19a618f8e58.webp";